module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/system-setting-component/update-application-settings/update-application-settings.component.scss
// module id = ./src/app/system-setting-component/update-application-settings/update-application-settings.component.scss
// module chunks = main